requestAnimationFrame(() => {
  scriptController.executeWhenScriptLoaded(['modal-dialog.js'], () => {
    function throttle(func, delay) {
        let lastCall = 0;

        return function(...args) {
          const now = Date.now();
          if (now - lastCall >= delay) {
            lastCall = now;
            func.apply(this, args);
          }
        };
      }

      if (!customElements.get('cart-drawer')) {
        class CartDrawer extends ModalDialog {
          constructor() {
            super();

            if (window.addToCartAction === 'cart_drawer' && !window.location.pathname.includes('/cart')) {
              subscribe(PUB_SUB_EVENTS.cartUpdateFinish, this.show.bind(this));
            }

            this.throttledCheckFooter = throttle(this.updateFooterState.bind(this), 400);
            scriptController.scripts.push('cart-drawer.js');
          }

          show(arg) {
            const fromAddToCart = arg && typeof arg === 'object' && arg.source === 'product-form';

            super.show(fromAddToCart ? undefined : arg);

            if (Shopify.designMode) return;

            this.startFooterUpdates();

            if (fromAddToCart) {
              this.guardCheckoutButtons();
            }
          }

          guardCheckoutButtons(duration = 800) {
            if (this.checkoutGuardTimeout) clearTimeout(this.checkoutGuardTimeout);

            this.querySelectorAll('#cart-drawer-footer-buttons [name="checkout"]').forEach(button => {
              if (button.disabled && !button.dataset.checkoutGuard) return;

              button.dataset.checkoutGuard = 'true';
              button.setAttribute('disabled', 'disabled');
            });

            this.checkoutGuardTimeout = setTimeout(() => {
              this.querySelectorAll('[data-checkout-guard="true"]').forEach(button => {
                button.removeAttribute('disabled');
                delete button.dataset.checkoutGuard;
              });
              this.checkoutGuardTimeout = null;
            }, duration);
          }

          startFooterUpdates() {
            const update = () => {
              this.throttledCheckFooter();
              this.animationId = requestAnimationFrame(update);
            };
            this.animationId = requestAnimationFrame(update);
          }

          updateFooterState() {
            this.footer = this.querySelector('.cart-drawer__footer');
            this.itemsWrapper = this.querySelector('.cart-drawer__items');
            this.items = this.itemsWrapper.querySelectorAll('.cart-drawer-item');
            this.notesDropdown = this.footer.querySelector('.animated-dropdown__dropdown');
            let footerHeight = this.footer.offsetHeight;

            if (this.notesDropdown) {
              footerHeight -= this.notesDropdown.offsetHeight;
            }

            let itemsBottomLimit = this.itemsWrapper.offsetTop + footerHeight;

            this.items.forEach((element, index) => {
              if (index >= 2) return false;
              itemsBottomLimit = itemsBottomLimit + (index === 0 ? element.offsetHeight : element.offsetHeight / 2);
            });

            this.footer.classList[
              themeBase.windowHeight < itemsBottomLimit ? 'add' : 'remove'
            ]('cart-drawer__footer--static');
          }

          hide(callback) {
            cancelAnimationFrame(this.animationId);
            super.hide(callback);
          }
        }

        customElements.define('cart-drawer', CartDrawer);
      }
  });
});